module.exports = __webpack_public_path__ + "static/img/BRL.2fec504.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BRL.svg
// module id = MMSD
// module chunks = 1